const data = {
  defaultText: 'Ingresa tu dirección de envío',
};

export default data;
